import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import classNames from 'classnames';
import TooltipOnHover from '../../../components/TooltipOnHover';
export var BASE_CLASS_NAME = classNames('slite-editor-table-control-icon', 'pointer position-absolute background-white transition shade-20', 'flexbox flexbox-align-center flexbox-justify-center', 'padding-smaller radius-normal shadow-normal zindex-large');

function TableIconWrapper(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      className = _ref.className,
      tooltipContent = _ref.tooltipContent,
      _ref$tooltipPlacement = _ref.tooltipPlacement,
      tooltipPlacement = _ref$tooltipPlacement === void 0 ? 'left' : _ref$tooltipPlacement,
      props = _objectWithoutProperties(_ref, ["style", "className", "tooltipContent", "tooltipPlacement"]);

  return React.createElement(TooltipOnHover, {
    id: "slite-editor-table-control",
    placement: tooltipPlacement,
    tooltipContent: tooltipContent
  }, React.createElement("div", Object.assign({
    className: classNames(BASE_CLASS_NAME, className),
    style: style
  }, props)));
}

export default React.memo(TableIconWrapper);